import { Stack, styled as muiStyled } from '@mui/material';
import styled from 'styled-components';

export const StyledLogoContainer = muiStyled(Stack, {
  shouldForwardProp: (prop) => prop !== 'setLength',
})<{ setLength: boolean }>`
  svg {
    width:  ${({ setLength }) => (setLength ? '150px' : 'auto')}
  }
`;

export const StyledFooterTabs = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #222;
  z-index: 1000;
`;
